"use client";

/**
 * NewForm DS hover icon — a microscope for "competitor research".
 * On hover the barrel leans into the eyepiece and the slide under the lens
 * pulses, as if a sample were being examined.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function ResearchIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-peer" style={{ transformOrigin: "50% 90%" }}>
        <path d="M11.6 4.2h2.6a1 1 0 0 1 1 1v4.4a1 1 0 0 1-1 1h-2.6a1 1 0 0 1-1-1V5.2a1 1 0 0 1 1-1Z" />
        <path d="M12.9 4.2V2.9" />
        <path d="M15.2 7.4a5.6 5.6 0 0 1 1.5 10.4" />
      </g>
      <path d="M4.2 21.1h15.6" />
      <path className="a-scan" d="M8.1 17.8h8.2" />
      <path d="M10.7 13.6h2.6" />
    </HoverIconSvg>
  );
}
